module.exports = __webpack_public_path__ + "static/img/cjfw-enterpriseCulture2.69c9a90b.png";